import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { BUTTON_SX, MARGIN_GAP } from "../../lib/constants.js";
import EditableField from "../EditableField.js";

export default function CreationDialog({
  actionButtonText,
  bodyPrimary,
  closeButtonText,
  inputId,
  inputLabel,
  inputValue,
  icon: Icon,
  iconColor,
  locales,
  onActionClick,
  onClose,
  onInput,
  show,
  title,
}) {
  return (
    <Dialog open={show}>
      {Icon ? (
        <Box display="flex" justifyContent="center" mt={MARGIN_GAP}>
          <Icon color={iconColor || "secondary"} fontSize="large" />
        </Box>
      ) : null}
      {title ? (
        <DialogTitle component="h2" variant="h6" align="center" gutterBottom>
          {title}
        </DialogTitle>
      ) : null}
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <DialogContentText color="text.primary">
          {bodyPrimary}
        </DialogContentText>
        <Box display="flex" alignItems="start">
          <EditableField
            id={inputId}
            isEditing={true}
            label={inputLabel}
            onChange={onInput}
            text={inputValue}
            value={inputValue}
            variant="body1"
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "space-around" }}>
        <Button
          onClick={onActionClick}
          color="secondary"
          disabled={!inputValue}
          size="large"
          sx={BUTTON_SX.DISABLED}
        >
          {actionButtonText}
        </Button>
        <Button
          onClick={onClose}
          color={actionButtonText && onActionClick ? "primary" : "secondary"}
          size="large"
        >
          {closeButtonText || locales["button.cancel"]}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
